module.exports = __webpack_public_path__ + "img/gb950.prt.8465eebf.jpg";